import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ComplaintCategory } from '@icc/b2b/shared';
import { ConfigService } from '@icc/shared';
import { Common } from '@icc/shared/helpers';

@Component({
    selector: 'icc-complaint-position-configuration-select',
    templateUrl: './complaint-position-configuration-select.component.html',
    styleUrls: ['./complaint-position-configuration-select.component.scss'],
})
export class ComplaintPositionConfigurationSelectComponent implements OnInit, OnChanges {
    @Input() first = false;
    @Input() parent: any;
    @Input() parentOptions!: ComplaintCategory[];
    @Output() parentChange = new EventEmitter<ComplaintCategory>();
    childOptions: ComplaintCategory[] = [];

    constructor(
        private configService: ConfigService,
    ) {}

    ngOnInit(): void {
        this.updateChildOptions();
        this.filterStatisticalCategories();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // When parent changes externally, update childOptions
        if (changes['parent'] && !changes['parent'].firstChange) {
            this.updateChildOptions();
        }
        // When parentOptions changes, re-filter and update
        if (changes['parentOptions'] && !changes['parentOptions'].firstChange) {
            this.filterStatisticalCategories();
            this.updateChildOptions();
        }
    }

    private updateChildOptions(): void {
        if (this.parent?.id && this.parentOptions) {
            this.childOptions = this.parentOptions.find((el) => Number(el.id) === Number(this.parent.id))?.children ?? [];
        } else {
            this.childOptions = [];
        }
    }

    private filterStatisticalCategories(): void {
        if (this.configService.user?.user?.ActiveCompanyLicenseType !== 'license' || this.configService.user?.user?.ActivePanel === 'complaintb2c') {
            this.parentOptions = this.parentOptions?.filter((el) => !el.isStatisticalCategory) ?? [];
        }
    }

    allParentOptionsAreStatistical(): boolean {
        return this.parentOptions.every(option => option.isStatisticalCategory === true);
    }

    onChangeParentOption(event: string) {
        const option = this.parentOptions.find((el) => Number(el.id) === Number(event));
        if (this.configService.user?.user?.ActiveCompanyLicenseType === 'license' && this.configService.user?.user?.ActivePanel !== 'complaintb2c') {
            this.childOptions = option?.children ?? [];
        } else {
            this.childOptions = option?.children ? option.children.filter((el) => !el.isStatisticalCategory) : [];
        }
        if (this.parent) {
            if (event === 'null' || Common.isObject(event)) {
                delete this.parent.id;
                delete this.parent.name;
                delete this.parent.children;
                delete this.parent.isStatisticalCategory;
            } else {
                this.parent.id = event;
                this.parent.name = option?.name;
                this.parent.children = {};
                this.parent.isStatisticalCategory = option?.isStatisticalCategory;
            }
        }
    }
}
